import Video from 'client/components/entities/VideoNew'
import { EntityProps } from 'client/types'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import React from 'react'

function WebinarSessionVideo({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<VideoInterface>) {
  return (
    <Video
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    />
  )
}

export default WebinarSessionVideo
